import { lazy, Suspense, type ComponentProps, type FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import styles from './styles.scss';

const LazySinglePersonalizedCollectionBanner = lazy(
    () =>
        import(
            /* webpackChunkName: "SinglePersonalizedCollectionBanner" */ './SinglePersonalizedCollectionBanner.tsx'
        )
);

export const SinglePersonalizedCollectionBannerLoading: FC<{ isMobile: boolean }> = ({
    isMobile,
}) => (
    <div
        style={{ height: isMobile ? '200px' : '475px' }}
        className={cn(dibsCss.flex, dibsCss.flexCol, dibsCss.mbLarger)}
    >
        <span
            className={cn(
                dibsCss.mtMedium,
                dibsCss.mbMedium,
                dibsCss.pMedium,
                dibsCss.hLarge,
                dibsCss.w300px,
                styles.animate,
                dibsCss.roundedSmall
            )}
        />
        <div className={cn(dibsCss.flex, dibsCss.justifyBetween, dibsCss.pxLarge)}>
            {[1, 1, 1, 1, 1].map((_, index) => (
                <div
                    style={{ height: isMobile ? '166px' : '266px' }}
                    key={index}
                    className={cn(
                        dibsCss.wFull,
                        dibsCss.hAuto,
                        dibsCss.mxMedium,
                        styles.animate,
                        dibsCss.roundedSmall
                    )}
                />
            ))}
        </div>
    </div>
);

const SuspendedSinglePersonalizedCollectionBanner: FC<
    ComponentProps<typeof LazySinglePersonalizedCollectionBanner>
> = props => {
    return (
        <Suspense
            fallback={<SinglePersonalizedCollectionBannerLoading isMobile={props.isMobile} />}
        >
            <LazySinglePersonalizedCollectionBanner {...props} />
        </Suspense>
    );
};

export default SuspendedSinglePersonalizedCollectionBanner;
